<div class="client-notes">
  <div class="heading-wrapper">
    <div class="d-flex heading-wrapper_title">
      <h4 class="m-0">
        {{ 'pages.serviceProcessing.processNotes.title' | translate }}
      </h4>
      <app-tooltip [marginBottom]="true" text="readingRoomSubmissionNotes" />
    </div>
    <button class="secondary" (click)="openAddNoteModal()">
      <i class="bi bi-plus-circle" alt="add"></i>
      {{ 'components.updateClientNoteItem.add' | translate }}
    </button>
  </div>

  @if (!notes?.length) {
    <p class="no-notes">
      {{ 'pages.client.notes.noNotes' | translate }}
    </p>
  } @else {
    <div class="table_wrapper">
      <table class="table my-0">
        <thead>
          <tr>
            <td>
              {{ 'pages.client.notes.table.text' | translate }}
            </td>
            <td>
              {{ 'pages.client.notes.table.registrationInfo' | translate }}
            </td>
            <td>
              {{ 'pages.client.notes.table.files' | translate }}
            </td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          @for (note of notes; track note.id) {
            <tr>
              <td class="text">
                <p>{{ note.text }}</p>
              </td>
              <td>
                <p>{{ note.user.firstName }} {{ note.user.lastName }}</p>
                <p>{{ formatDatetime(note.createdOn) }}</p>
              </td>
              <td>
                <app-file-upload
                  [noPadding]="true"
                  [isEditMode]="false"
                  [existingFiles]="note.readingRoomSubmissionNoteFiles || []"
                  [type]="submissionNoteFileType"
                  [associatedEntityId]="note.id"
                  [isSubmitting]="false" />
              </td>
              <td>
                @if (userId === note.userId) {
                  <div class="action-btn_wrapper">
                    <button class="action-btn link" (click)="openEditNoteModal(note)">
                      <img src="assets/images/edit-icon.svg" alt="edit icon" />
                      {{ 'components.table.edit' | translate }}
                    </button>
                    <button class="action-btn link" (click)="openConfirmModal(note.id)">
                      <i class="bi bi-trash" alt="edit"></i>
                      {{ 'components.updateClientNoteItem.remove' | translate }}
                    </button>
                  </div>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  <app-submission-note-modal
    [isOpen]="isAddNoteModalOpen"
    [application]="application"
    (cancel)="isAddNoteModalOpen = false"
    (update)="onNoteSaved($event)" />

  <app-submission-note-modal
    [isOpen]="isEditNoteModalOpen"
    [application]="application"
    [note]="editingNote"
    (cancel)="isEditNoteModalOpen = false"
    (update)="onNoteSaved($event)" />
</div>
<app-confirm-modal
  [isOpen]="isOpenConfirmDeleteNote"
  (confirm)="handleRemove(noteToDelete!)"
  (cancel)="onModalClose()"
  title="deleteClientNote" />
